import {ApiEndpointUrl, Logintoken} from "../../common";
export const addressPoint = { list:ApiEndpointUrl + "addresses",
                              add:ApiEndpointUrl + "addresses/create" ,    
                              delete:ApiEndpointUrl + "addresses/create" };
  